<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center>
      <v-flex md12>
        <div v-if="loading">Carregando leads...</div>
        <material-card
          color="success"
          title="Leads"
          text="Leads cadastrados na plataforma"
          v-if="!$apollo.loading"
        >
          <v-form ref="form" v-model="valid" lazy-validation v-if="!loading">
            <v-container>
              <v-layout>
                <v-flex xs3 md3 class="text-lg-left">
                  <v-text-field
                    v-model="name"
                    label="Nome"
                    class="purple-input"
                    @keyup.enter="_search"
                  />
                </v-flex>
                <v-flex xs3 md3 class="text-lg-left">
                  <v-text-field
                    v-model="email"
                    label="Email"
                    class="purple-input"
                    @keyup.enter="_search"
                  />
                </v-flex>
                <v-flex xs3 md3 class="text-lg-left">
                  <v-text-field
                    v-model="phone"
                    label="Telefone"
                    class="purple-input"
                    _search
                  />
                </v-flex>
                <!-- <v-flex
                        xs3
                        md3
                        class="text-lg-left"
                    >
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="start_date"
                            label="Data Inicial"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="start_date" @input="menu = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex
                        xs3
                        md3
                        class="text-lg-left"
                    >
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="end_date"
                            label="Data Inicial"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="end_date" @input="menu2 = false"></v-date-picker>
                      </v-menu>
                    </v-flex> -->
                <v-flex xs2 md2 class="text-lg-left">
                  <v-btn
                    color="success"
                    outline
                    small
                    slot="start"
                    @click="_search"
                    :disabled="!valid || loading_search"
                    :loading="loading_search"
                  >
                    <v-icon left>search</v-icon>Buscar
                  </v-btn>
                </v-flex>
                <v-flex xs2 md2 class="text-lg-left">
                  <v-btn
                    color="tertiary"
                    small
                    outline
                    slot="start"
                    @click="_clear"
                    :disabled="!valid || loading_search"
                  >
                    <v-icon left>clear</v-icon>Limpar
                  </v-btn>
                </v-flex>
                <v-flex xs3 md3 class="text-lg-right">
                  <div class="text-xs-rigth text-md-rigth text-lg-rigth">
                    <v-btn
                      class="mx-0 font-weight-light"
                      color="primary"
                      outline
                      small
                      :disabled="loading || loading_search || loading_export"
                      :loading="loading_export"
                      @click.prevent="openMyDialog"
                      ><v-icon left dark>get_app</v-icon>Exportar</v-btn
                    >
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <!-- <v-layout>
            <v-flex sm12 md8>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex sm12 md4 text-xs-right text-md-right>
              <v-btn class="mx-0 font-weight-light" color="secondary" @click.prevent="newLead()">
                <v-icon left dark>add</v-icon>Nova Proposta
              </v-btn>
            </v-flex>

            <v-flex md12 sm6 lg4></v-flex>
            <v-flex md12 sm6 lg8>
              <v-layout>
                <v-flex md12 sm4 lg4>
                  <v-icon>access_time</v-icon>&nbsp;Aguardando conta
                </v-flex>
                <v-flex md12 sm4 lg4>
                  <v-icon>send</v-icon>&nbsp;Proposta Enviada
                </v-flex>
                <v-flex md12 sm4 lg4>
                  <v-icon color="blue">done</v-icon>&nbsp;Contrato Assinado
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout> -->
          <!-- <v-flex xs12 md12 class="text-lg-right">
            <div class="text-xs-rigth text-md-rigth text-lg-rigth" v-if="leads.length > 0">
              <v-btn color="primary" outline slot="start" @click="_export(leads)">
                <v-icon left>mdi-file-excel</v-icon>Exportar
              </v-btn>
            </div>
          </v-flex> -->
          <template v-slot:loading>
            <v-progress-linear
              v-if="loading"
              height="3"
              color="cyan"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-data-table
            :headers="headers"
            :items="items"
            :total-items="totalItems"
            :pagination.sync="pagination"
            :rows-per-page-items="rowsPerPageItems"
            :loading="loading"
            no-data-text="Não há leads cadastrados"
            rows-per-page-text="Linhas por página"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.created_at | formatarDate }}</td>
              <td>
                {{
                  item.signedcontract_at
                    ? item.signedcontract_at
                    : item.updated_at | formatarDate
                }}
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>
                <a
                  :href="`https://web.whatsapp.com/send?phone=+55${limpaPhone(
                    item.phone,
                  )}&text=${
                    item.termouso
                      ? whatsApp_message_customer
                      : whatsApp_message_lead
                  } *Para continar seu cadastro acesse* https://cadastro.enercred.com.br?email=${
                    item.email
                  }&source=super.enercred.com.br&data=`"
                  target="_blank"
                  >{{ item.phone }}</a
                >
              </td>
              <!-- <td
                class="text-xs-right"
              >{{ item.state?typeof item.state === 'object'?item.state.initials:item.state:'' || '' }}</td> -->
              <td>{{ item.titular }}</td>
              <td class="text-xs-right">{{ item.average_consumption || 0 }}</td>
              <td>{{ item.concessionaria || "" }}</td>
              <td>{{ item.termouso || "" }}</td>
              <!-- <td class="text-xs-right">
                <img src="@/assets/icons/bill.png" alt="conta" v-if="item.bills">
                <v-badge overlap color="cyan" v-if="item.emailconta && item.emailconta > 0">
                  <template v-slot:badge>
                    <span>{{item.emailconta}}</span>
                  </template>
                  <v-icon v-if="!item.bills" @click="enviarEmail(item, process.env.VUE_APP_SENDGRID_TEMPLATE_CONTAPENDENTE)">mail</v-icon>
                </v-badge>
                <v-icon v-if="!item.bills && (!item.emailconta || item.emailconta === 0)" @click="enviarEmail(item)">mail</v-icon>
              </td>
              <td>
                <template>
                  <v-icon 
                    v-if="item.step <= 1"
                    @click="proposta(item, 2)"
                  >
                      access_time
                  </v-icon>
                  <v-icon 
                    v-if="item.step === 2"
                    @click="proposta(item, 3)"
                  >
                      send
                  </v-icon>
                  <v-icon 
                    color="blue"
                    v-if="item.step === 3"
                  >
                      done
                  </v-icon>
                </template>
              </td>-->
              <td>
                <v-badge
                  overlap
                  color="cyan"
                  v-if="
                    item.emailconta &&
                    item.emailconta > 0 &&
                    item.termouso !== 'Sim'
                  "
                >
                  <template v-slot:badge>
                    <span>{{ item.emailconta }}</span>
                  </template>
                  <v-icon
                    v-if="
                      item.termouso !== 'Sim' &&
                      (item.emailconta || item.emailconta > 0)
                    "
                    @click="
                      enviarEmailLead(
                        { email: item.email, name: item.name },
                        recuperalead_template,
                      )
                    "
                    >email</v-icon
                  >
                </v-badge>
                <v-icon
                  v-if="
                    item.termouso !== 'Sim' &&
                    (!item.emailconta || item.emailconta === 0)
                  "
                  @click="
                    enviarEmailLead(
                      { email: item.email, name: item.name },
                      recuperalead_template,
                    )
                  "
                  >email</v-icon
                >
              </td>
              <td>
                <v-icon @click="getLeadDetail(item.email)">visibility</v-icon>
              </td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning"
                >Sua busca para "{{ name || email || phone }}" não retornou
                resultados.</v-alert
              >
            </template>
            <template v-slot:pageText="items"
              >Linhas {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }}</template
            >
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <cpnCreateExport />
    <v-dialog
      v-model="dialog"
      full-width
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="secondary">
          <v-toolbar-title>Editar Lead</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 md12>
          <cpn-lead-detail :lead="lead"></cpn-lead-detail>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
import statesfile from "@/model/state";
import { eventBus } from "../main";
import CreateExport from "../components/export/CreateExport";
import { enviarEmail } from "../services/sendmail";
import {
  updateLead, //, getLeads
} from "../services/leads";
import firestore from "../firebase/firestore";
import LeadDetail from "./Lead";
import XLSX from "xlsx";
import { mapState } from "vuex";

// import { eventBus } from '../main'

export default {
  data: () => ({
    // start_date: new Date().toISOString().substr(0, 10),
    // end_date: new Date().toISOString().substr(0, 10),
    start_date: "",
    end_date: "",
    menu: false,
    menu2: false,
    leads: [],
    name: "",
    email: "",
    phone: "",
    lead: {},
    valid: false,
    consumo: {
      meses: [],
      medicaoMin: 0,
      mediaConsumo: 0,
    },
    contrato: {},
    emailPronto: false,
    usinas: [],
    PowerPlant: "",
    bills: "",
    search: "",
    totalItemsProcess: 0,
    pagination: {
      rowsPerPage: 25, // -1 for All",
    },
    pagination_before: {},
    rowsPerPageItems: [5, 10, 25],
    items: [],
    items_complete: [],
    totalItems: 0,
    loading: false,
    loading_search: false,
    loading_export: false,
    dialog: false,
    whatsApp_message_customer:
      "Olá, *seja bem-vindo(a) a Enercred!* ⚡ Parabéns por entrar para o mundo da economia e sustentabilidade. Meu nome é *Caio* e estou aqui para te ajudar. Agora vamos informar para a CEMIG sobre os seus descontos, para isso preciso das seguintes informações: 1. *RG*: 2. *Órgão Emissor*: 3. *Estado civil*: 4. *Regime de bens*:5. *Profissão*. Caso tenha alguma dúvida ou precise de outra informação, pode me enviar uma mensagem por aqui.",
    whatsApp_message_lead:
      "Olá, aqui quem fala é o *Caio da Enercred*, vi que você iniciou o cadastro em nossa plataforma. Como posso te ajudar para que você possa economizar em sua conta de luz? Qualquer dúvida, pode me responder essa mensagem!",
    data: [
      [
        "Indice",
        "Criado em",
        "Atualizado",
        "Assinado em",
        "E-mail",
        "Nome",
        "Telefone",
        "Estado",
        "Média de Consumo",
        "Concessionaria",
        "Titular da Conta",
        "Assinou Termo de uso",
        "Qtde de Emails Retorno Lead",
        "promo_code",
        "Origem do Lead",
        "Meio de Origem",
        "Campanha",
      ],
    ],
    headers: [
      {
        sortable: true,
        text: "Criado",
        value: "created_at",
      },
      {
        sortable: true,
        text: "Atualizado",
        value: "updated_at",
      },
      {
        sortable: true,
        text: "Nome",
        value: "name",
      },
      {
        sortable: true,
        text: "E-mail",
        value: "email",
      },
      {
        sortable: false,
        text: "Tel.",
        value: "phone",
      },
      {
        sortable: true,
        text: "Titular?",
        value: "titular",
      },
      {
        sortable: true,
        text: "Consumo",
        value: "average_consumption",
        align: "right",
      },
      // {
      //   text: '',
      //   sortable: false,
      //   name: 'contas'
      // },
      // {
      //   text: '  ',
      //   sortable: false,
      //   name: 'step'
      // },
      {
        text: "Concessionaria",
        sortable: true,
        name: "concessionaria",
      },
      {
        text: "Termo",
        sortable: true,
        name: "termouso",
      },
      {
        text: "  ",
        sortable: false,
        name: "email",
      },
      {
        text: "   ",
        sortable: false,
        name: "edit",
      },
    ],
    showMenu: false,
    x: 0,
    y: 0,
    actions: [
      {
        title: "Proposta enviada",
        icon: "send",
        iconClass: "blue white--text",
        value: 2,
      },
      {
        title: "Contrato Assinado",
        icon: "person",
        iconClass: "amber white--text",
        value: 3,
      },
      {
        title: "Solicitar nova conta",
        icon: "person",
        iconClass: "blue white--text",
        value: 4,
      },
    ],
    states: statesfile.estados,
    classes: [
      {
        nome: "1 - Monofásico",
        valor: 30,
      },
      {
        nome: "2 - Bifásico",
        valor: 50,
      },
      {
        nome: "3 - Trifásico",
        valor: 100,
      },
    ],
    modalidades: [
      "Convencional B1",
      "Convencional B2",
      "Convencional B3",
      "Comercial B1",
      "Comercial B2",
      "Comercial B3",
      "Comercial A1",
      "Comercial A2",
      "Comercial A3",
    ],
    emailRules: [
      (v) => !!v || "Por favor, informe o email",
      (v) => /.+@.+/.test(v) || "E-mail precisa ser válido",
    ],
    nameRules: [
      (v) => !!v || "Por favor, informe o nome",
      (v) => v.length >= 10 || "Por favor, preencha seu nome completo.",
    ],
    recuperalead_template: process.env.VUE_APP_SENDGRID_TEMPLATE_RECUPERALEAD,
  }),
  components: {
    cpnLeadDetail: LeadDetail,
    cpnCreateExport: CreateExport,
  },
  computed: {
    ...mapState(["user"]),
    config() {
      return this.$store.state.config;
    },
  },
  watch: {
    pagination: {
      handler() {
        const {
          // sortBy, descending,
          page,
          rowsPerPage,
        } = this.pagination;

        // console.log('pagination: ', this.pagination)

        // console.log('befor_page: ', this.pagination_before.page)
        // console.log('next_page: ', this.pagination.page)
        // console.log('page: ', this.pagination.page)
        // console.log('page_cont', (this.items_complete.length/rowsPerPage))
        /* 
          Se selecionou página anterior
          Pega os dados direto do array items_complete
          */
        if (
          this.pagination_before &&
          this.pagination_before.page > this.pagination.page
        ) {
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          this.loading = false;

          /*
          Se selecionou proxima página, mas a pagina selecionada já foi carregada antes
          Pega os dados direto do array items_complete
          */
        } else if (
          this.pagination_before &&
          this.pagination_before.page <= this.pagination.page &&
          this.pagination.page <= this.items_complete.length / rowsPerPage
        ) {
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          this.loading = false;

          // Se a pagina é a mesma não faz nada
        } else if (this.pagination_before.page === this.pagination.page) {
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          this.loading = false;

          /*
          Se selecionou proxima página, e a pagina selecionada ainda não foi carregada antes
          Busca os dados no firebase e adiciona ao array os dados firebase
          */
        } else {
          this.pagination_before = this.pagination;
          if (this.last) {
            this.loading = true;
            const {
              // sortBy, descending,
              page,
              rowsPerPage,
            } = this.pagination;
            let params = {
              last: this.last,
            };
            if (this.name) {
              params.name = this.name;
            } else if (this.email) {
              params.email = this.email;
            } else if (this.phone) {
              params.phone = this.phone;
            } else if (this.start_date && this.end_date) {
              params.start_date = this.start_date;
              params.end_date = this.end_date;
            }
            // console.log('watch params: ', params)
            this.getLeads(params).onSnapshot((res) => {
              this.last = res.docs[res.docs.length - 1];
              const changes = res.docChanges();
              if (res.docs.length < this.pagination.rowsPerPage) {
                this.totalItems =
                  (this.pagination.page - 1) * this.pagination.rowsPerPage +
                  res.docs.length;
                this.pagination.totalItems = this.totalItems;
              }
              // console.log('changes: ', changes)
              changes.forEach((change) => {
                // console.log('change.type: ', change.type)
                if (change.type === "added") {
                  // const customer_id = change.doc.data().user_id
                  this.items.push({
                    ...change.doc.data(),
                    id: change.doc.id,
                  });
                  this.items_complete.push({
                    ...change.doc.data(),
                    id: change.doc.id,
                  });
                  this.loading = false;
                } else if (change.type === "modified") {
                  // this.items.push({
                  //     ...change.doc.data(),
                  //     id: change.doc.id,
                  //   })
                  // const customer_id = change.doc.data().user_id
                  // console.log('modified: ', customer_id)
                } else {
                  this.loading = false;
                }
                // var source = res.metadata.fromCache ? "local cache" : "server";
                // console.log("Data came from " + source);
              });
            });
            if (rowsPerPage > 0) {
              this.items = this.items.slice(
                (page - 1) * rowsPerPage,
                page * rowsPerPage,
              );
            }
          } else {
            this.loading = false;
          }
        }
      },
      deep: true,
    },
  },
  created() {
    // console.log('pagination: ', this.pagination)
    this.$store.dispatch("setInitialsConfig");
    this.loading = true;
    this.items_complete = [];
    this.items = [];
    // console.log('total: ', this.config.leads.total)
    this.totalItems = this.config.leads.total || 0;
    this.pagination.totalItems = this.config.leads.total || 0;
    // const { sortBy, descending, rowsPerPage } = this.pagination
    const params = {};
    this.getLeads(params).onSnapshot((res) => {
      const changes = res.docChanges();
      this.last = res.docs[res.docs.length - 1];
      if (res.docs.length < this.pagination.rowsPerPage) {
        this.totalItems =
          (this.pagination.page - 1) * this.pagination.rowsPerPage +
          res.docs.length;
        this.pagination.totalItems = this.totalItems;
      }
      changes.forEach((change) => {
        if (change.type === "added") {
          this.items.push({
            ...change.doc.data(),
            id: change.doc.id,
          });
          this.items_complete.push({
            ...change.doc.data(),
            id: change.doc.id,
          });
          this.loading = false;
        } else if (change.type === "modified") {
          // const customer_id = change.doc.data().user_id
          // console.log('modified: ', customer_id)
        } else {
          this.loading = false;
        }
      });
    });
  },
  beforeCreate() {
    this.$store.dispatch("setInitialsConfig");
  },
  methods: {
    getLeads(params) {
      // console.log('params: ', params)
      let ref = firestore.collection("leads");

      if (params.name) {
        ref = ref.where("name_insensitive", ">=", params.name.toLowerCase());
      } else if (params.email) {
        ref = ref.where("email", ">=", params.email);
      } else if (params.phone) {
        ref = ref.where("phone", ">=", params.phone);
        // ref = ref.where('phone', '==', params.phone)
      } else if (params.start_date || params.end_date) {
        let order_by = "desc";
        if (params.start_date) {
          order_by = "asc";
          ref = ref.where("updated_at", ">=", new Date(params.start_date));
        }
        if (params.end_date) {
          ref = ref.where("updated_at", "<=", new Date(params.end_date));
        }
        ref = ref.orderBy("updated_at", order_by);
      }
      ref = ref.limit(this.pagination.rowsPerPage || 25);

      if (params.name) {
        ref = ref.orderBy(
          "name_insensitive",
          this.pagination.descending ? "desc" : "asc",
        );
      } else if (params.email) {
        ref = ref.orderBy("email", "asc");
      } else {
        // ref = ref.orderBy('created_at', this.pagination.descending?'desc':'asc')
        ref = ref.orderBy("updated_at", "desc");
      }

      if (params.last) {
        ref = ref.startAfter(this.last);
      }
      return ref;
    },
    async _search() {
      this.loading_search = true;
      // console.log('search: ', this.name.toUpperCase())
      this.items = [];
      this.items_complete = [];
      this.last = null;
      this.pagination_before = {};

      let params = {};
      if (this.name) {
        params.name = this.name;
      } else if (this.email) {
        params.email = this.email;
      } else if (this.phone) {
        params.phone = this.phone;
      } else if (this.start_date || this.end_date) {
        params.start_date = this.start_date;
        params.end_date = this.end_date;
      }
      this.getLeads(params)
        .get()
        .then((res) => {
          // console.log('leads qtde: ', leads.size)
          this.last = res.docs[res.docs.length - 1];
          if (res.size > 0) {
            if (res.size < this.pagination.rowsPerPage) {
              this.totalItems =
                (this.pagination.page - 1) * this.pagination.rowsPerPage +
                res.size;
              this.pagination.totalItems = this.totalItems;
            }
            res.docs.map(async (snapshot, index) => {
              this.items.push({
                index,
                ...snapshot.data(),
                id: snapshot.data().id,
              });
              this.items_complete.push({
                index,
                ...snapshot.data(),
                id: snapshot.data().id,
              });
              if (res.size - 1 === index) {
                this.loading_search = false;
              }
            });
          } else {
            this.loading_search = false;
          }
        })
        .catch((error) => {
          console.error(error);
          this.loading_search = false;
        });
      this.pagination = {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        totalItems: this.totalItems,
      };
      const {
        // sortBy,
        page,
        rowsPerPage,
      } = this.pagination;

      if (rowsPerPage > 0) {
        this.items = this.items.slice(
          (page - 1) * rowsPerPage,
          page * rowsPerPage,
        );
      }
    },
    openMyDialog() {
      eventBus.$emit("dialog_export", true); // emit the event to the bus
    },
    async _clear() {
      this.loading_search = true;
      // console.log('search: ', this.name.toUpperCase())
      this.items = [];
      this.items_complete = [];
      this.last = null;
      this.pagination_before = {};
      this.name = "";
      this.email = "";
      this.phone = "";
      this.start_date = "";
      this.end_date = "";
      this.totalItems = this.config.leads.total;
      // console.log('totalItems: ', this.totalItems)
      this._search();
    },
    async _export() {
      this.loading_export = true;
      /* convert state to workbook */
      const leads = await firestore
        .collection("leads")
        .orderBy("created_at", "desc")
        .get();
      // console.log('size: ', leads.size)
      await leads.docs.map((doc, index) => {
        // item.id = index
        let item = doc.data();
        // console.log(item)
        this.data.push([
          index + 1,
          this.formatarData(item.created_at),
          this.formatarData(item.updated_at),
          item.signedcontract_at
            ? this.formatarData(item.signedcontract_at)
            : this.formatarData(item.updated_at),
          item.email,
          item.name,
          item.phone,
          item.state ? item.state.initials : "",
          item.average_consumption,
          item.concessionaria,
          item.titular,
          item.termouso,
          item.emailconta,
          item.promo_code,
          item.utm_source,
          item.utm_medium,
          item.utm_campaign,
        ]);

        if (leads.size - 1 === index) {
          const ws = XLSX.utils.aoa_to_sheet(this.data);
          const wb = XLSX.utils.book_new();

          const file = "leads_" + this.formatFileName(new Date());
          XLSX.utils.book_append_sheet(wb, ws, file);
          /* generate file and send to client */
          XLSX.writeFile(wb, file + ".xlsx");
          this.loading_export = false;
        }
        // console.log('data: ', this.data)
      });
      // console.log('data: ', this.data)
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    // async fetchPowerPlants() {
    //   getPowerPlants()
    //     .then((result) => {
    //       if(result.data) {
    //         result.data.map((usina) => {
    //           if(usina.PowerPlantId.substring(0, 3) == 'ufv'){
    //             this.usinas.push(usina.item);
    //           }
    //         })
    //       }
    //     })
    //     .catch(err => {
    //       console.log('Error: ', err);
    //     })
    // },
    async newLead() {
      this.$router.push({ path: "/lead/" });
    },
    async getLeadDetail(id) {
      this.loading = true;
      this.$router.push({ path: "/lead/" + id, params: { id: id } });
    },
    // async buscarEndereco() {
    //   if(this.lead.cep.length >= 8) getCep(this.lead.cep)
    //     .then((result) => {
    //       if(result.data){
    //         this.lead.cidade = result.data.localidade;
    //         this.lead.bairro = result.data.bairro;
    //         this.lead.estado = result.data.uf;
    //         this.lead.endereco = result.data.logradouro;
    //       }
    //     })
    // },
    calcularProposta: function (lead, consumo, contrato, usinas, PowerPlant) {
      consumo.mediaConsumo = 0;
      consumo.custoDisp = 0;
      consumo.desvioPadrao = 0;
      contrato.creditos = 0;
      contrato.descAnual = 0;
      consumo.percPlant = 0;
      /*
      // Calcula a proposta do membro considerando:
      // - Consumo Médio dos últimos 12 meses informados
      // - Custo do KwH
      // - Quantidade Minima de kWh considerados
      // - Desvio Padrão dos últimos 12 meses informados
      // - Custo de Disponibilidade conforme a classe / instalação do clinte
      */
      var lista = [];
      let cont = 0;
      let consumoMin =
        consumo.medicaoMin === "" || consumo.medicaoMin === 0
          ? 0
          : consumo.medicaoMin;

      /*
      // Cria lista conforme consumo minimo definido
      // Ignora valores abaixo do consumo Minimo informado
      */
      for (let i = 0; i < 12; i++) {
        if (consumo.meses[i] > parseInt(consumoMin)) {
          lista[cont] = consumo.meses[i];
          cont++;
        }
      }
      if (cont <= 0) {
        alert("Informar consumo(s) mensal(is)");
        return;
      }
      /*
      // Calcula a media de consumo em kWh do membro
      */
      let media = lista.reduce(
        (resultado, valor) => resultado + valor / lista.length,
        0,
      );
      consumo.mediaConsumo = parseInt(media);

      /*
      // Calcula o desvio padrão entre o consumo dos ultimos 12 meses do membro
      */
      let variancia = lista.reduce(
        (resultado, valor) =>
          resultado + Math.pow(media - valor, 2) / lista.length,
        0,
      );
      let desvioPadrao = Math.sqrt(variancia);
      consumo.desvioPadrao = parseInt(desvioPadrao);

      /*
      // Identifica o custo de disponibildiade conforme a classe do membro
      // O Custo de disponibilidade será cobrado do membro independente dos crtéditos ou consumo do membro
      // Monofasico = 30 kWh
      // Binofasico = 50 kWh
      // Trifasico = 100 kWh
      */
      let custoDisponibilidade = !lead.classe ? 0 : parseInt(lead.classe);
      if (!custoDisponibilidade || custoDisponibilidade < 30) {
        alert("Informar a classe da conta");
        return;
      }
      consumo.custoDisp = custoDisponibilidade;

      /*
      // Identifica o preco do kWh
      // Essa variavel será utilizada para compor os créditos aproximados e valor de mensalidade estimado
      */
      if (lead.precokwh && lead.precokwh.search(","))
        lead.precokwh = lead.precokwh.replace(",", ".");
      let preco = !lead.precokwh ? 0 : parseFloat(lead.precokwh).toFixed(2);
      if (!lead.precokwh || !preco || preco <= 0) {
        alert("Informar preço do KWh");
        return;
      }

      /*
      // Calcula a quantidade de créditos ideal para o membro
      // O Calculo é feito com base na média de consumo - custo de disponibilidade - desvio padrão
      */
      let consumoFinal = media - custoDisponibilidade - desvioPadrao;
      let creditos = consumoFinal * preco;
      contrato.creditos = creditos.toFixed(2);

      /*
      // Calcula a mensalidade estimada ideal para o membro
      // O Calculo é feito sempre baseando-se em um desconto de 20% emcima do total de créditos adquiridos
      */
      let mensalidade = creditos * 0.8;
      contrato.mensalidade = mensalidade.toFixed(2);

      /*
      // Calcula o desconto anual estimado para o membro com base nos
      // créditos recebidos - mensalidade * 12 meses
      */
      let desconto = ((creditos - mensalidade) * 12).toFixed(2);
      contrato.descAnual = desconto;

      /*
      // Filtra no array de usinas a usina selecionada
      // Calcula o percentual de consumo em relação ao total da planta
      */
      if (PowerPlant) {
        let usinaArr = usinas.filter(function (usina) {
          return PowerPlant.includes(usina.id);
        });
        consumo.percPlant = (
          (consumoFinal / usinaArr[0].power_month) *
          100
        ).toFixed(2);
      } /* else {
        alert('Selecione uma usina');
        return;
      }*/

      // Disponibilizar botão para enviar proposta
      this.emailPronto = true;
    },
    async enviarProposta() {
      const data = {
        email: this.lead.email,
        name: this.lead.name,
        dynamic_template_data: {
          nome: this.lead.name,
          average: this.consumo.mediaConsumo,
          custo_disp: this.consumo.custoDisp,
          desvio_padrao: this.consumo.desvioPadrao,
          creditos: this.contrato.creditos,
          economia_mensal: this.contrato.mensalidade,
          economia_total: this.contrato.descAnual * 3,
        },
        template_id: process.env.VUE_APP_SENDGRID_TEMPLATE_CONTRATO,
      };
      enviarEmail(data)
        .then(() => {
          alert("Email enviado ao lead com sucesso!");
        })
        .catch((error) => {
          console.error("Erro ao enviar email ao lead. ", error);
          alert("Erro ao enviar email ao lead. ", error);
        });
    },
    async enviarEmailLead(lead, template) {
      const data = {
        email: lead.email,
        name: lead.name,
        dynamic_template_data: {
          name: lead.name,
          email: lead.email,
        },
        template_id: template,
      };

      // console.log("conteudo lead: ", data)

      enviarEmail(data)
        .then(() => {
          if (lead.emailconta && typeof lead.emailconta === "number") {
            lead.emailconta++;
          } else {
            lead.emailconta = 1;
          }

          // console.log("envia_lead:", JSON.stringify(lead))

          updateLead(lead.email, lead)
            .then(alert("E-mail enviado com sucesso!"))
            .catch((error) => {
              console.error(
                "Erro ao atualizar envio de email do lead. ",
                error,
              );
              alert("Erro ao atualizar envio de email do lead. ", error);
            });
        })
        .catch((error) => {
          console.error("Erro ao enviar email. ", error);
          alert("Ops! Falha ao enviar email.", error);
        });
    },
    async proposta(select_lead, value) {
      select_lead.step = value;
      await updateLead(select_lead.email, select_lead)
        .then(() => {
          this.$nextTick(() => {
            alert("Dado atualizado com sucesso!");
          });
        })
        .catch((error) => {
          console.error("Erro ao atualizar os dados. ", error);
          alert("Erro ao atualizar os dados. ", error);
        });
    },
    async update(select_lead) {
      await updateLead(select_lead.email, select_lead)
        .then(() => {
          this.$nextTick(() => {
            alert("Dado atualizado com sucesso!");
          });
        })
        .catch((error) => {
          console.error("Erro ao atualizar os dados. ", error);
          alert("Erro ao atualizar os dados. ", error);
        });
    },
    newBill(select_lead) {
      //Solicita ao usuário nova conta, pois a atual não está legivel
      select_lead.step = 1;
      this.enviarEmail(
        select_lead,
        process.env.VUE_APP_SENDGRID_TEMPLATE_NOVACONTA,
      );
    },
    formatarData: function (value) {
      if (!value) return "-";
      let timestamp = value; // firebase data

      // myDate = timestamp.toDate()
      // if(timestamp.valueOf().seconds) {
      //   myDate = timestamp.toDate()
      // } else if(timestamp.valueOf()._seconds) {
      //   myDate = new Date(timestamp._seconds * 1000) // date object
      // } else {
      //   return '-'
      // }
      return moment(timestamp.toISOString()).format("DD/MM/YYYY");
      // if (!value) return ""
      // console.log(value);
      // // console.log(value)
      // // value = value.toString()
      // let timestamp = value // firebase data
      // let myDate = new Date(timestamp._seconds * 1000) // date object

      // // console.log(myDate)
      // return moment(myDate.toISOString()).format("DD/MM/YYYY")
    },
    limpaPhone: function (value) {
      if (!value) return "";
      return value.toString().replace(/\D/g, "");
    },
  },
  filters: {
    formatStep: function (value) {
      var step_text = "";
      if (!value) return "";

      if (value === "0") {
        step_text = "Sem contas";
      } else if (value === "1") {
        step_text = "Gerando propostas";
      } else {
        step_text = "error";
      }
      return step_text;
    },
    formatPhone: function (value) {
      if (!value) return "";
      var clearphone = value.toString().replace(/\D/g, "");
      return (
        "<a href='https://web.whatsapp.com/send?phone=" +
        clearphone +
        "&text=&source=&data='>" +
        value +
        "</a>"
      );
    },
  },
};
</script>
<style scoped>
.zoom {
  transition: transform 0.2s;
  margin: 0 auto;
}

.zoom:hover {
  -ms-transform: scale(1.4); /* IE 9 */
  -webkit-transform: scale(1.4); /* Safari 3-8 */
  transform: scale(1.4);
}
</style>
